export default {"src":"/_next/static/media/gas-slateus.08e75f71.svg","height":100,"width":100};